import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/menu/modifierGroupsModifierItemFactory.ts
var modifierGroupsModifierItemFactoryCore = (modifierGroups, state) => {
  const currentMenu = state.menu.selectedMode.currentMenu;
  const menuModifierGroups = currentMenu.modifierGroups;
  const menuModifierItems = currentMenu.modifierItems;
  const resultModifierGroups = Object.values(
    modifierGroups
  ).map((modifierGroup) => {
    const menuModifierGroup = menuModifierGroups[modifierGroup.modifierGroupId];
    const data = menuModifierGroup ? {
      posName: menuModifierGroup.posName,
      description: menuModifierGroup.posName,
      multiselect: menuModifierGroup.multiselect,
      quantityMode: menuModifierGroup.quantityMode,
      modifierGroupPricingVersions: menuModifierGroup.modifierGroupPricingVersions,
      defaultModifierGroupPricingVersionId: modifierGroups[modifierGroup.modifierGroupId].defaultModifierGroupPricingVersionId,
      priceCalcMode: menuModifierGroup.priceCalcMode,
      defaultSelectionPrice: modifierGroups[modifierGroup.modifierGroupId].defaultSelectionPrice,
      hidePriceIfFree: menuModifierGroup.hidePriceIfFree
    } : {
      posName: "",
      description: "",
      multiselect: false,
      quantityMode: "Off" /* OFF */,
      modifierGroupPricingVersions: [],
      defaultModifierGroupPricingVersionId: null,
      priceCalcMode: "max",
      defaultSelectionPrice: 0,
      hidePriceIfFree: false
    };
    const modifierGroupPricingVersions = Object.values(data.modifierGroupPricingVersions).length > 0 ? [
      Object.values(data.modifierGroupPricingVersions).map(
        (modifierGroupPricingVersion) => ({
          label: modifierGroupPricingVersion.name,
          value: modifierGroupPricingVersion.modifierGroupPricingVersionId
        })
      )
    ] : [];
    return __spreadProps(__spreadValues({}, modifierGroup), {
      posName: data.posName,
      multiselect: data.multiselect,
      quantityMode: data.quantityMode,
      description: data.description,
      defaultModifierGroupPricingVersionId: data.defaultModifierGroupPricingVersionId,
      modifierGroupPricingVersions,
      priceCalcMode: data.priceCalcMode,
      defaultSelectionPrice: data.defaultSelectionPrice,
      hidePriceIfFree: data.hidePriceIfFree
    });
  }).sort((a, b) => a.sortPriority - b.sortPriority);
  const resultModifierGroupsData = resultModifierGroups.map((modifierGroup) => {
    const modifierItems = Object.values(modifierGroup.modifierItems).map((modifierItem) => {
      const modifierName = menuModifierItems[modifierItem.modifierItemId] ? menuModifierItems[modifierItem.modifierItemId].name : "";
      const modItemPricingVersions = menuModifierGroups[modifierGroup.modifierGroupId].modifierGroupPricingVersions[modifierGroup.defaultModifierGroupPricingVersionId].modItemPricingVersions;
      if (Object.values(modItemPricingVersions).length > 0) {
        const pricingVersionId = modItemPricingVersions[modifierItem.modifierItemId];
        const pricingVersion = menuModifierItems[modifierItem.modifierItemId].modifierItemPricingVersions[pricingVersionId];
        return __spreadProps(__spreadValues({}, modifierItem), {
          name: modifierName,
          includedMasterPrice: pricingVersion.includedMasterPrice,
          additionalMasterPrice: pricingVersion.additionalMasterPrice,
          quarterPricePercent: pricingVersion.quarterPricePercent,
          halfPricePercent: pricingVersion.halfPricePercent,
          includedLightPrice: pricingVersion.includedLightPrice,
          includedRegularPrice: pricingVersion.includedRegularPrice,
          includedExtraPrice: pricingVersion.includedExtraPrice,
          additionalLightPrice: pricingVersion.additionalLightPrice,
          additionalRegularPrice: pricingVersion.additionalRegularPrice,
          additionalExtraPrice: pricingVersion.additionalExtraPrice
        });
      } else {
        return __spreadProps(__spreadValues({}, modifierItem), {
          name: modifierName,
          includedMasterPrice: 0,
          additionalMasterPrice: 0,
          quarterPricePercent: 0,
          halfPricePercent: 0,
          includedLightPrice: 0,
          includedRegularPrice: 0,
          includedExtraPrice: 0,
          additionalLightPrice: 0,
          additionalRegularPrice: 0,
          additionalExtraPrice: 0
        });
      }
    }).sort((a, b) => a.sortPriority - b.sortPriority).reduce(
      (acc, mi) => __spreadProps(__spreadValues({}, acc), {
        [mi.modifierItemId]: __spreadProps(__spreadValues({}, mi), {
          modifierItemId: mi.modifierItemId
        })
      }),
      {}
    );
    return __spreadProps(__spreadValues({}, modifierGroup), {
      modifierItems
    });
  });
  return resultModifierGroupsData;
};

export { modifierGroupsModifierItemFactoryCore };
